export default "__VITE_ASSET__d1fc873b__"